import axios from 'axios';
import { useEffect, useState } from 'react';
import { Button, Card, Col, Row, Tab, Table, Tabs } from 'react-bootstrap';
import { Link, useLocation, useNavigate } from 'react-router-dom';

import { FaDailymotion, FaDribbbleSquare, FaSearchengin } from 'react-icons/fa';
import Pagination from '../../Pagination';
import DashboardLayout from './DashboardLayout ';
import DreamApplication from './DreamApplications';
import GlobalHRSettings from './GlobalHRSettings';
import SearchAndShortlist from './SearchAndShortlist';

const Applications = () => {
  const BASE_API_URL = process.env.REACT_APP_API_URL;
  const navigate = useNavigate();
  const location = useLocation();
  const userName = location.state?.userName;
  const userEmail = location.state?.userEmail;

  const currentJobApplicationPage = location.state?.currentJobApplicationPage || 0;
  const currentJobApplicationPageSize = location.state?.currentJobApplicationPageSize || 6;
  const [jobs, setJobs] = useState('')
  const [search, setSearch] = useState('');
  const [page, setPage] = useState(currentJobApplicationPage);
  const [pageSize, setPageSize] = useState(currentJobApplicationPageSize);
  const [totalPages, setTotalPages] = useState(0);
  const [sortedColumn, setSortedColumn] = useState(null); // Track the currently sorted column
  const [sortOrder, setSortOrder] = useState(' '); // Track the sort order (asc or desc)
  const [loading, setLoading] = useState(true);


  const initialTab = location.state?.activeTab;
  const [activeTab, setActiveTab] = useState(initialTab || 'applications');

  const isLastPage = page === totalPages - 1;
  const isPageSizeDisabled = isLastPage;


  const handlePageSizeChange = (e) => {
    const size = parseInt(e.target.value);
    setPageSize(size);
    setPage(0); // Reset page when page size change
  };
  const handlePageClick = (data) => {
    const selectedPage = Math.max(0, Math.min(data.selected, totalPages - 1)); // Ensure selectedPage is within range
    setPage(selectedPage);
    localStorage.setItem('currentApplicationPage', selectedPage); // Store the page number in localStorage
  };

  useEffect(() => {
    localStorage.setItem('currentViewPage', 0);
    if (search) {
      fetchJobBysearch();
    }
    else {
      fetchJobs()
    }

  }, [userEmail, search, page, pageSize, sortOrder, sortedColumn]);

  useEffect(() => {
    const storedPage = localStorage.getItem('currentApplicationPage');
    if (storedPage !== null) {
      const parsedPage = Number(storedPage);
      if (parsedPage < totalPages) {
        setPage(parsedPage);
      }
    }
  }, [totalPages]);


  const fetchJobs = async () => {
    setLoading(true);
    try {
      const params = {
        userEmail: userEmail,
        page: page,
        size: pageSize,
        sortBy: sortedColumn, // Include sortedColumn and sortOrder in params
        sortOrder: sortOrder,
      };
      const response = await axios.get(`${BASE_API_URL}/jobsByHrEmail`, { params });
      setJobs(response.data.content);
      setTotalPages(response.data.totalPages);
      setLoading(false);
    } catch (error) {
    }
  }

  const handleSearchChange = (e) => {
    setSearch(e.target.value);
    setPage(0); // Reset page when page size change
  }
  const fetchJobBysearch = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${BASE_API_URL}/searchJobsByHR`, {
        params: { search, userEmail, page, pageSize }
      });
      setJobs(response.data.content);
      setTotalPages(response.data.totalPages);
      setLoading(false);
    } catch (error) {
      alert("Error searching for jobs. Please try again later.");
    }

  }
  useEffect(() => {
    if (location.state?.currentJobApplicationPage === undefined && location.state?.currentJobApplicationPageSize === undefined) {
      setPage(0);
      setPageSize(6)
    }
  }, [location.state?.currentJobApplicationPage, location.state?.currentJobApplicationPageSize]);
  const handleSort = (column) => {
    let order = 'asc';
    if (sortedColumn === column) {
      order = sortOrder === 'asc' ? 'desc' : 'asc';
    }
    setSortedColumn(column);
    setSortOrder(order);
  };

  const state1 = location.state || {};

  // Assuming customTabHeader is a helper function that renders tab headers with icons
  const customTabHeader = (title, icon) => (
    <div className="d-flex align-items-center">
      <span className="me-2">
        {icon}
      </span>
      <span class="fs-6 fw-bold">{title}</span>
    </div>
  );

  // Function to handle tab selection and update state
  const handleTabClick = (key) => {
    setActiveTab(key);
  };
  return (


    <DashboardLayout>
      <div className="main-content" style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
        <Row className="d-flex justify-content-between align-items-center" style={{ marginBottom: '20px' }}>
          <Col xs="auto">
            <h2>
              <div className="text-start">Applications</div>
            </h2>
          </Col>
          <Col xs="auto">
            <GlobalHRSettings />
          </Col>
        </Row>
        <Tabs activeKey={activeTab}
          onSelect={handleTabClick} id="hr-tabs" className="mb-3">
          {/* Tab 1: Applications */}
          <Tab eventKey="applications" title={customTabHeader("Job Applications", <FaDribbbleSquare />)}>


            <Row>
              <Col md={4}></Col>
              <Col md={4} className="d-flex align-items-left">
                <div className="search-bar" style={{ flex: 1 }}>
                  <input
                    style={{
                      borderColor: '#6c5b7b',
                      borderRadius: '6px',
                      height: '40px',
                      width: '50%',
                      padding: '0 10px',
                      marginRight: '20px',
                      marginBottom: '10px',
                    }}
                    type="text"
                    name="search"
                    placeholder="Search"
                    value={search}
                    onChange={handleSearchChange}
                  />
                </div>
              </Col>
            </Row>

            {loading ? (
              <div className="d-flex justify-content-center align-items-center">
                <div className="spinner-bubble spinner-bubble-primary m-5" />
                <span>Loading...</span>
              </div>
            ) : jobs.length > 0 ? (
              <>
                <Card body>
                  <div className="table-details-list table-wrapper">
                    <Table  hover responsive  >
                      <thead>
                        <tr>
                          <th onClick={() => handleSort('jobTitle')} style={{ cursor: 'pointer' }}>
                            Job Title{' '}
                            <span>
                              <span style={{ color: sortedColumn === 'jobTitle' && sortOrder === 'asc' ? 'black' : 'gray' }}>↑</span>{' '}
                              <span style={{ color: sortedColumn === 'jobTitle' && sortOrder === 'desc' ? 'black' : 'gray' }}>↓</span>
                            </span>
                          </th>
                          <th onClick={() => handleSort('applicationDeadline')} style={{ cursor: 'pointer' }}>
                            Application Deadline{' '}
                            <span>
                              <span
                                style={{
                                  color: sortedColumn === 'applicationDeadline' && sortOrder === 'asc' ? 'black' : 'gray',
                                }}
                              >
                                ↑
                              </span>{' '}
                              <span
                                style={{
                                  color: sortedColumn === 'applicationDeadline' && sortOrder === 'desc' ? 'black' : 'gray',
                                }}
                              >
                                ↓
                              </span>
                            </span>
                          </th>
                          <th>Action</th>
                        </tr>
                      </thead>

                      <tbody>
                        {jobs.map((job) => (
                          <tr key={job.jobId}>
                            <td>{job.jobTitle}</td>
                            <td>{job.applicationDeadline || <span style={{ color: 'green' }}>Evengreen Job</span>}</td>
                            <td>
                              <Link
                                to="/hr-dashboard/hr-applications/view-applications"
                                onClick={(e) => {
                                  e.preventDefault();
                                  navigate('/hr-dashboard/hr-applications/view-applications', {
                                    state: {
                                      userName,
                                      userEmail,
                                      jobId: job.jobId,
                                      jobTitle:job.jobTitle,
                                      currentJobApplicationPage: page,
                                      currentJobApplicationPageSize: pageSize,
                                      companyName: job.companyName,
                                    },
                                  });
                                }}
                                className="nav-link"
                              >
                                <Button>View Application</Button>
                              </Link>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </div>

                  {/* Pagination */}
                  <Pagination
                    page={page}
                    pageSize={pageSize}
                    totalPages={totalPages}
                    handlePageSizeChange={handlePageSizeChange}
                    isPageSizeDisabled={isPageSizeDisabled}
                    handlePageClick={handlePageClick}
                  />
                </Card>
              </>
            ) : (
              <section>
                <h2>No Applications</h2>
              </section>
            )}
          </Tab>

          {/* Tab 2: Placeholder */}
          <Tab eventKey="dreamApplication" title={customTabHeader("Applicants as Dream Company", <FaDailymotion />)}>
            <DreamApplication />
          </Tab>

          {/* Tab 3: Placeholder */}
          <Tab eventKey="settings" title={customTabHeader("Directly Shortlisted (search and shortlist)", <FaSearchengin />)}>
            <SearchAndShortlist />
          </Tab>
        </Tabs>
      </div>
    </DashboardLayout>

  );
}

export default Applications;


